import { combineReducers } from "redux";

/**
 * Main reducers
 */
import {style} from './styles'
import {user} from './user'

export const mainReducer = combineReducers({
    user: user,
    style
})

export const containerReducer = combineReducers({
    main: mainReducer
})